import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';
import React, { useState } from 'react';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

export interface MenuItem {
    handler: () => void;
    title: string;
    subtitle?: string;
    disabled?: boolean;
    variant?: 'default' | 'destructive';
    className?: string;
}

interface Props {
    menuItems: MenuItem[];
    icon: React.ReactElement;
    idSuffix?: string | number;
    /** Merged onto the trigger's own classes. */
    className?: string;
}

const KebabMenu: React.FC<Props> = (props) => {
    const [open, setOpen] = useState(false);
    const { menuItems, icon, idSuffix, className } = props;
    const suffix = idSuffix !== undefined ? `-${idSuffix}` : '';
    const buttonId = `menu-handler${suffix}`;
    const menuId = `buttons-menu${suffix}`;

    return (
        <div>
            <DropdownMenu open={open} onOpenChange={setOpen}>
                <DropdownMenuTrigger
                    id={buttonId}
                    aria-label={t('actions')}
                    aria-controls={menuId}
                    disabled={menuItems.length == 0}
                    className={cn(
                        'hover:text-primary inline-flex size-12 cursor-pointer items-center justify-center rounded-full text-[1.5rem] disabled:pointer-events-none disabled:opacity-50',
                        open ? 'text-primary bg-grey-200' : 'text-grey-500 bg-paper',
                        // In the new design it sits on whatever it is drawn on, a list row's stripe included.
                        'new:hover:bg-neutral-tint',
                        open ? 'new:bg-neutral-tint' : 'new:bg-transparent',
                        className
                    )}
                >
                    {icon}
                </DropdownMenuTrigger>
                <DropdownMenuContent id={menuId} className="w-auto">
                    {menuItems.map((menuItem) => (
                        <DropdownMenuItem
                            key={menuItem.title}
                            disabled={menuItem.disabled}
                            variant={menuItem.variant}
                            className={menuItem.className}
                            onClick={() => {
                                menuItem.handler();
                                setOpen(false);
                            }}
                        >
                            {menuItem.subtitle ? (
                                <div className="flex flex-col">
                                    <span>{menuItem.title}</span>
                                    <span className="text-xs text-gray-500">{menuItem.subtitle}</span>
                                </div>
                            ) : (
                                menuItem.title
                            )}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

export default KebabMenu;
